import React, { useState, useEffect, createContext, useContext } from 'react';
import BasicDetails from './basicDetails';
import AgencyDetails from './agencyDetails';
import { GET_STAKEHOLDER_BY_URN, UPDATE_HIT, ResourceUpdateMember, ALLOCATE_WORKFLOW, INITIATE_WORKFLOW_FOR_REG_SCRU, CHECK_USER_DISTRICT_MAPPING } from '../../../../common/URLs';
import { API_DATE_FORMAT, PROD, RESOURCE_ROLES, ROLES } from '../../../../common/constants';
import moment from 'moment';
import jwt from 'jwt-decode';
import { useNavigate, useLocation } from "react-router-dom";
import { loaderService } from '../../../../common/custom-loader/loader-service';
import { getLocalStorageItem } from '../../../../common/localStorageUtils';
import { toast } from 'react-toastify';
import { Button, Box, Typography, TextField, Grid, Stack, Container } from "@mui/material";
import Preview from '../preview';
import BackButton from '../../../../common/backButton';
import { useTranslation } from "react-i18next";
import { VALIDATION, emailValidation } from '../../../../common/commonValidations';
import { GetRecentCommentObject } from '../../../../common/commonFunction';
import { getAllComments, insertComment } from '../commonRegistrationStakeholderAPIs';
import { PreviewIcon, SaveIcon } from '../../../../common/icons';
import _ from 'lodash';
import { appInsights } from '../../../../AppInsights';
import apiClient from '../../../../axios';

const HitContext = createContext();

function RegistrationDetailsHit(props) {
  const { state } = useLocation();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const urn = state?.URN ? state.URN : props.urn;
  const [documentsArray, setDocumentsArray] = useState();
  const [commentsData, setCommentsData] = useState();
  const [comments, setComments] = useState([]);
  const decoded = jwt(getLocalStorageItem('id_token'));
  let userRole = localStorage.getItem('role');
  let uuid = localStorage.getItem('uuid');
  const [expandedSection, setExpandedSection] = useState("personal");
  const [errorMessage, setErrorMessage] = useState({
    contactPersonFirstNameError: '',
    emailIdError: '',
    addressError: '',
    panNumberError: '',
    accountNumberError: '',
    accountHolderNameError: '',
    ifscCodeError: '',
    otherCardError: '',
    idProofDocError: '',
    addressProofDocError: '',
    tradeLicenseDocError: '',
    labourLicenseDocError: '',
    bankStatementError: '',
    bankDocError: '',
    applicantTypeError: '',
    fullNameError: '',
    mobileNoError: '',
    idProofError: '',
    gstNumberError: '',
    agreementDateError: '',
    documentError: '',
    gstDocError: '',
    agreementDocError: '',
    manpowerVechicletableError: '',
    gstNumberError: '',
    agreementDateError: '',
    documentError: '',
    gstDocError: '',
    agreementDocError: '',
    manpowerVechicletableError: '',
    panDocError: ""
  });
  const [currentPage, setCurrentPage] = useState("registrationDetails");
  const [buttonAction, setButtonAction] = useState("");
  const [callUpdateApi, setCallUpdateApi] = useState(false);
  const [showCommentSection, setShowCommentSection] = useState(false);
  const [regScruResourceUpdate, setRegScruResourceUpdate] = useState(false);
  const [stakeHolderDetails, setStakeHolderDetails] = useState();
  const [showWorkFlowButtons, setShowWorkFlowButtons] = useState(false);
  const [showClarificationButton, setShowClarificationButton] = useState(false);
  const [enableSaveSubmitButtons, setEnableSaveSubmitButtons] = useState(false);
  const [personalDetailsSectionOk, setPersonalDetailsSectionOk] = useState(false);
  const [agreementDetailsSectionOk, setAgreementDetailsSectionOk] = useState(false);
  const [bankDetailsSectionOk, setBankDetailsSectionOk] = useState(false);
  const [vehicleDetailsSectionOk, setVehicleDetailsSectionOk] = useState(false);
  const [shouldActOnSection, setShouldActOnSection] = useState({
    personal_details: false,
    bank_details: false,
    agreement_details: false,
    vehicle_details: false
  });
  const [callWorkFlowApi, setCallWorkFlowApi] = useState(false);
  const [basicHitDetails, setBasicHitDetails] = useState({
    applicantType: "",
    name: "",
    contactPersonName: "",
    contactPersonGender: "",
    emailId: "",
    mobileNo: "",
    govtIdCardType: "Aadhaar ID",
    govtIdCardNumber: "",
    otherGovtCardType: "",
    certificateType: "",
    certificateNumber: "",
    panNumber: null,
    hitLabourLicenseNo: "",
    labourLicenseEndDate: moment(new Date).format(API_DATE_FORMAT),
    hitTradeLicenseNo: "",
    tradeLicenseEndDate: moment(new Date).format(API_DATE_FORMAT),
    bankAccountNumber: "",
    bankAccountHolderName: "",
    bankBranch: "",
    bankIfscCode: "",
    address: "",
    pincode: "",
    state: "",
    district: "",
    blockName: "",
    revenueCircle: "",
    contactPersonFirstName: '',
    contactPersonMiddleName: '',
    contactPersonLastName: '',
    contactPersonSalutation: 'Mr',
    contactPersonGender: 'Male',
  });
  const [address, setAddress] = useState('');
  const [verifyMobileNo, setVerifyMobileNo] = useState(false);
  const [mobileOTPValidated, setMobileOTPValidated] = useState(false);
  const [otpHidden, setOtpHidden] = useState(true);
  const [otpValue, setOtpValue] = useState();
  const [hitDetails, setHitDetails] = useState();
  const [bankDetails, setBankDetails] = useState();
  const [nextPage, setNextPage] = useState(false);
  const [prevPage, setPrevPage] = useState(true);
  const [updateHitResponse, setUpdateHitResponse] = useState();
  const [submit, setSubmit] = useState(false);
  const [agencyUpdatedDetails, setAgencyUpdatedDetails] = useState();
  const [saveAndExit, setSaveAndExit] = useState(false);
  const [documents, setDocuments] = useState();
  const [logModalOpen, setLogModalOpen] = useState(false);
  const handleLogModalOpen = () => setLogModalOpen(true);
  const handleLogModalClose = () => setLogModalOpen(false);
  const [isMSMERadio, setIsMSMERadio] = useState("NO");
  const [msmeCategory, setMsmeCategory] = useState("");

  useEffect(() => {
    if (urn) {
      getHitDetails();
    }
  }, [urn]);

  useEffect(() => {
    if (hitDetails) {
      const hitMaster = hitDetails?.stakeHolder?.hitMasters[0];
      const regStakeholderMaster = hitMaster?.regStakeholderMaster;
      const totalManpowerConcatenateValue = parseInt(hitMaster?.hitDriverDetails.length + hitMaster?.hitHarvesterDetails.length)
      const totalVehicleCountConcatenateValue = parseInt(hitMaster?.hitVehicleDetails?.length)
      setBasicHitDetails({
        ...basicHitDetails,
        name: regStakeholderMaster?.name,
        contactPersonName: regStakeholderMaster?.contactPersonSalutation + " " + regStakeholderMaster?.contactPersonFirstname + " " + regStakeholderMaster?.contactPersonMiddlename + " " + regStakeholderMaster?.contactPersonLastname,
        contactPersonGender: regStakeholderMaster?.contactPersonGender,
        emailId: regStakeholderMaster?.emailId,
        mobileNo: regStakeholderMaster?.mobileNo,
        govtIdCardType: hitDetails?.stakeHolder?.govtIdCardType ? hitDetails?.stakeHolder?.govtIdCardType : "Aadhaar ID",
        govtIdCardNumber: hitDetails?.stakeHolder?.govtIdCardNumber,
        otherGovtCardType: hitDetails?.stakeHolder?.otherGovtCardType,
        certificateType: hitMaster?.certificateType,
        certificateNumber: hitMaster?.certificateNumber,
        panNumber: regStakeholderMaster?.panNumber,
        hitLabourLicenseNo: hitMaster?.hitLabourLicenseNo,
        labourLicenseEndDate: hitMaster?.labourLicenseEndDate ? hitMaster?.labourLicenseEndDate : moment(new Date).format(API_DATE_FORMAT),
        hitTradeLicenseNo: hitMaster?.hitTradeLicenseNo,
        tradeLicenseEndDate: hitMaster?.tradeLicenseEndDate ? hitMaster?.tradeLicenseEndDate : moment(new Date).format(API_DATE_FORMAT),
        bankAccountNumber: regStakeholderMaster?.bankAccountNumber,
        bankAccountHolderName: regStakeholderMaster?.bankAccountHolderName,
        bankBranch: regStakeholderMaster?.bankBranch,
        bankIfscCode: regStakeholderMaster?.bankIfscCode,
        bankName: regStakeholderMaster?.bankName,
        address: hitMaster?.address,
        pincode: hitMaster.pincode,
        state: hitMaster.state,
        district: hitMaster.district,
        blockName: hitMaster.blockName,
        revenueCircle: hitMaster.revenueCircle,
        contactPersonFirstName: regStakeholderMaster?.contactPersonFirstname,
        contactPersonMiddleName: regStakeholderMaster?.contactPersonMiddlename,
        contactPersonLastName: regStakeholderMaster?.contactPersonLastname,
        contactPersonSalutation: regStakeholderMaster?.contactPersonSalutation,
        applicantType: hitMaster.applicantType,
        registrationCompleted: hitDetails?.stakeHolder?.registrationCompleted,
        registrationStatus: hitDetails?.stakeHolder?.registrationStatus

      });
      setAddress(hitMaster?.address)
      setDocumentsArray(hitMaster.documents);
      // console.log("inside", hitDetails?.stakeHolder?.hitMasters[0])
      setAgencyUpdatedDetails({
        ...hitMaster,
        totalManpower: totalManpowerConcatenateValue,
        totalVehicleCount: totalVehicleCountConcatenateValue
      });
      setIsMSMERadio(
        hitDetails?.stakeHolder?.isMSME === 1 ? "YES" : "NO"
      );
      setMsmeCategory(
        hitDetails?.stakeHolder?.msmeCategory || ""
      );

    }

  }, [hitDetails]);

  useEffect(() => {
    if (callUpdateApi) {
      appInsights.trackEvent({
        name: 'Details Changed',
        properties: {
          timeStamp: new Date().toISOString(),
          user: decoded.extension_URN ? decoded.extension_URN : localStorage.getItem('email')
        }
      })
      if (buttonAction === "submit" && userRole === ROLES?.RegistrationScruitnizer && state?.userType === "Internal") {
        onCheckUserDistrictMapping();
      }
      else updateHit();
    }
  }, [callUpdateApi]);

  const onCheckUserDistrictMapping = () => {
    loaderService.showLoader();
    apiClient.post(CHECK_USER_DISTRICT_MAPPING,
      {
        "state": stakeHolderDetails?.hitMasters?.[0]?.state,
        "plotDistrict": stakeHolderDetails?.hitMasters?.[0]?.district
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
      .then((response) => {
        if (response.data.isSuccess === true) {
          updateHit();
        } else {
          toast.error(response.data?.message)
        }
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();

      });
  };

  useEffect(() => {
    const loggedInUser = decoded.extension_URN ? stakeHolderDetails?.id : uuid
    setComments(commentsData);
    let personalCommentsInitial = commentsData?.filter((item) => item.sectionName === "personal_details");
    let bankCommentsInitial = commentsData?.filter((item) => item.sectionName === "bank_details");
    let agreementCommentsInitial = commentsData?.filter((item) => item.sectionName === "agreement_details");
    let vehicleCommentsInitial = commentsData?.filter((item) => item.sectionName === "vehicle_details");
    setPersonalDetailsSectionOk(GetRecentCommentObject(personalCommentsInitial)?.sectionOk ? GetRecentCommentObject(personalCommentsInitial)?.sectionOk : false);
    setBankDetailsSectionOk(GetRecentCommentObject(bankCommentsInitial)?.sectionOk ? GetRecentCommentObject(bankCommentsInitial)?.sectionOk : false);
    setAgreementDetailsSectionOk(GetRecentCommentObject(agreementCommentsInitial)?.sectionOk ? GetRecentCommentObject(agreementCommentsInitial)?.sectionOk : false);
    setVehicleDetailsSectionOk(GetRecentCommentObject(vehicleCommentsInitial)?.sectionOk ? GetRecentCommentObject(vehicleCommentsInitial)?.sectionOk : false);
    if (!enableSaveSubmitButtons && !showWorkFlowButtons && !showClarificationButton) {
      Object.keys(shouldActOnSection).forEach(key => {
        shouldActOnSection[key] = false;
      });
    }
    else if (userRole === RESOURCE_ROLES.PlantSCMMember) {
      Object.keys(shouldActOnSection).forEach(key => {
        shouldActOnSection[key] = false;
      });
    }
    else if (stakeHolderDetails?.scrutinyStatus === "Pending_Clarification" && stakeHolderDetails?.currentOwnerID === loggedInUser) {
      Object.keys(shouldActOnSection).forEach(key => {
        const section = commentsData?.find(obj => obj.sectionName === key && obj.isActive === 1);
        shouldActOnSection[key] = !section?.sectionOk;
      });
    }
    else {
      Object.keys(shouldActOnSection).forEach(key => {
        shouldActOnSection[key] = true;
      });
    }
  }, [commentsData]);

  const onGoBack = () => {
    setCurrentPage("registrationDetails")
  }

  const noCommentForMandatorySections = () => {
    if (stakeHolderDetails?.scrutinyStatus == "Submited_Clarification") {
      if (comments.find((item) => item.sectionName === "personal_details" && item.scrutinyAction === "Submited_Clarification" && item.isActive === 1) && !comments.find((item) => item.sectionName === "personal_details" && item.createdBy === (decoded.extension_URN ? hitDetails?.stakeHolder?.hitMasters[0]?.regStakeholderMasterId : uuid) && item.workflowStepDetailsId === null)) {
        setExpandedSection("personal");
        // toast.error("Please enter comment and save")
        setErrorMessage({ ...errorMessage, personalCommentError: "Please enter comment and save" });
        return true;
      }
      if (comments.find((item) => item.sectionName === "bank_details" && item.scrutinyAction === "Submited_Clarification" && item.isActive === 1) && !comments.find((item) => item.sectionName === "bank_details" && item.createdBy === (decoded.extension_URN ? hitDetails?.stakeHolder?.hitMasters[0]?.regStakeholderMasterId : uuid) && item.workflowStepDetailsId === null)) {
        setExpandedSection("bank");
        // toast.error("Please enter comment and save")
        setErrorMessage({ ...errorMessage, bankCommentError: "Please enter comment and save" });
        return true;
      }
      if (comments.find((item) => item.sectionName === "agreement_details" && item.scrutinyAction === "Submited_Clarification" && item.isActive === 1) && !comments.find((item) => item.sectionName === "agreement_details" && item.createdBy === (decoded.extension_URN ? hitDetails?.stakeHolder?.hitMasters[0]?.regStakeholderMasterId : uuid) && item.workflowStepDetailsId === null)) {
        setExpandedSection("agreement");
        // toast.error("Please enter comment and save")
        setErrorMessage({ ...errorMessage, agreementCommentError: "Please enter comment and save" });
        return true;
      }
      if (comments.find((item) => item.sectionName === "vehicle_details" && item.scrutinyAction === "Submited_Clarification" && item.isActive === 1) && !comments.find((item) => item.sectionName === "vehicle_details" && item.createdBy === (decoded.extension_URN ? hitDetails?.stakeHolder?.hitMasters[0]?.regStakeholderMasterId : uuid) && item.workflowStepDetailsId === null)) {
        setExpandedSection("vehicle");
        // toast.error("Please enter comment and save")
        setErrorMessage({ ...errorMessage, vehicleCommentError: "Please enter comment and save" });
        return true;
      }
    }
    else {
      if (shouldActOnSection.personal_details && !comments.find((item) => item.sectionName === "personal_details" && item.createdBy === (decoded.extension_URN ? hitDetails?.stakeHolder?.hitMasters[0]?.regStakeholderMasterId : uuid) && item.workflowStepDetailsId === null)) {
        setExpandedSection("personal");
        // toast.error("Please enter comment and save")
        setErrorMessage({ ...errorMessage, personalCommentError: "Please enter comment and save" });
        return true;
      }
      if (shouldActOnSection.bank_details && !comments.find((item) => item.sectionName === "bank_details" && item.createdBy === (decoded.extension_URN ? hitDetails?.stakeHolder?.hitMasters[0]?.regStakeholderMasterId : uuid) && item.workflowStepDetailsId === null)) {
        setExpandedSection("bank");
        // toast.error("Please enter comment and save")
        setErrorMessage({ ...errorMessage, bankCommentError: "Please enter comment and save" })
        return true;
      }
      if (shouldActOnSection.agreement_details && !comments.find((item) => item.sectionName === "agreement_details" && item.createdBy === (decoded.extension_URN ? hitDetails?.stakeHolder?.hitMasters[0]?.regStakeholderMasterId : uuid) && item.workflowStepDetailsId === null)) {
        setExpandedSection("agreement");
        // toast.error("Please enter comment and save")
        setErrorMessage({ ...errorMessage, agreementCommentError: "Please enter comment and save" });
        return true;
      }
      if (shouldActOnSection.vehicle_details && !comments.find((item) => item.sectionName === "vehicle_details" && item.createdBy === (decoded.extension_URN ? hitDetails?.stakeHolder?.hitMasters[0]?.regStakeholderMasterId : uuid) && item.workflowStepDetailsId === null)) {
        setExpandedSection("vehicle");
        // toast.error("Please enter comment and save")
        setErrorMessage({ ...errorMessage, vehicleCommentError: "Please enter comment and save" })
        return true;
      }
    }
    return false
  }

  const showPreview = () => {
    if (showCommentSection && (noCommentForMandatorySections())
    ) {
      toast.error("Please enter comments for required sections");
    }
    else {
      setErrorMessage({ ...errorMessage, landDetailsError: "" });
      enableSaveSubmitButtons && !_.isEqual(finalData, initialData) ? setCallUpdateApi(true) : setCurrentPage("preview");
      setButtonAction("preview")
    }
  }

  const checkValidations = () => {
    var idProof = documentsArray && documentsArray.filter((item) => item.documentType === "MOA_RegistrationCertificate" && (item.isActive == 1 || item.isActive == 3));
    var addProof = documentsArray && documentsArray.filter((item) => item.documentType === "IDProof" && (item.isActive == 1 || item.isActive == 3));
    var panDoc = documentsArray && documentsArray.filter((item) => item.documentType === "PANCard" && (item.isActive == 1 || item.isActive == 3));
    var bankdoc = documentsArray && documentsArray.filter((item) => item.documentType === "BankPassBook_CancelledCheque" && (item.isActive == 1 || item.isActive == 3));
    var bankStatement = documentsArray && documentsArray.filter((item) => item.documentType === "BankStatement" && (item.isActive == 1 || item.isActive == 3));

    if (basicHitDetails.applicantType.length == 0) {
      setErrorMessage({ applicantTypeError: "Please enter Applicant Type" });
      toast.error("Please enter Applicant Type")
      setExpandedSection("personal");
      return;
    }
    if (basicHitDetails.name.length == 0) {
      setErrorMessage({ fullNameError: "Please enter Full Name" });
      toast.error("Please enter Full Name")
      setExpandedSection("personal");
      return;
    }
    if (basicHitDetails.applicantType !== "Individual" && isMSMERadio === "YES") {

      if (!msmeCategory) {
        toast.error("Please select MSME category");
        setExpandedSection("personal");
        return;
      }

      const msmeDoc = documentsArray?.filter(
        d => d.documentType === "MSME_Certificate" &&
          (d.isActive === 1 || d.isActive === 3)
      );

      if (!msmeDoc || msmeDoc.length === 0) {
        setErrorMessage({
          ...errorMessage,
          msmeDocError: "Please upload MSME certificate"
        });
        toast.error("Please upload MSME certificate");
        setExpandedSection("personal");
        return;
      }
    }
    if (basicHitDetails.contactPersonFirstName.length == 0) {
      setErrorMessage({ contactPersonFirstNameError: "Please enter Contact Person First Name" });
      toast.error("Please enter Contact Person First Name")
      setExpandedSection("personal");
      return;
    }
    else if (basicHitDetails.mobileNo?.length == 0) {
      setErrorMessage({ mobileNoError: "Please enter Mobile Number" });
      toast.error("Please enter Mobile Number")
      setExpandedSection("personal");
      return;
    }
    if (userRole !== ROLES.ItAdmin) {
      if (basicHitDetails.emailId?.length == 0 || !emailValidation(basicHitDetails.emailId)) {
        setErrorMessage({ emailIdError: "Please enter valid Email Address" });
        toast.error("Please enter valid Email Address")
        setExpandedSection("personal");
        return;
      }
      else if (!basicHitDetails.panNumber || basicHitDetails.panNumber.length == 0) {
        setErrorMessage({ ...errorMessage, panNumberError: "Please enter PAN Number" });
        toast.error("Please enter PAN Number")
        setExpandedSection("personal");
        return;
      }
      else if (panDoc.length == 0) {
        setErrorMessage({ ...errorMessage, panDocError: "Please upload PAN document" });
        toast.error("Please upload PAN document");
        setExpandedSection("personal");
        return;
      }
      else if (basicHitDetails.panNumber && basicHitDetails.panNumber.length > 0 && !VALIDATION.panNumberValidation(basicHitDetails.panNumber)) {
        setErrorMessage({ ...errorMessage, panNumberError: "Please enter valid PAN Number" });
        toast.error("Please enter valid PAN Number")
        setExpandedSection("personal");
        return;
      }
      else if (!basicHitDetails.certificateType || basicHitDetails.certificateType?.length == 0) {
        setErrorMessage({ idProofError: "Please select ID Proof Type" });
        toast.error("Please select ID Proof Type")
        setExpandedSection("personal");
        return;
      }
      else if (!basicHitDetails.certificateNumber || basicHitDetails.certificateNumber?.length == 0) {
        setErrorMessage({ certificateNumberError: "Please enter ID Proof Number" });
        toast.error("Please enter ID Proof Number")
        setExpandedSection("personal");
        return;
      }
      else if (idProof.length == 0) {
        setErrorMessage({ idProofDocError: "Please upload ID Proof document" });
        toast.error("Please upload ID Proof document")
        setExpandedSection("personal");
        return;
      }
      else if (!basicHitDetails.govtIdCardNumber || basicHitDetails.govtIdCardNumber?.length == 0) {
        setErrorMessage({ govtIdCardNumberError: "Please enter Address Proof ID" });
        toast.error("Please enter Address Proof ID")
        setExpandedSection("personal");
        return;
      }
      else if (addProof.length == 0) {
        setErrorMessage({ addressProofDocError: "Please upload address proof document" });
        toast.error("Please upload address proof document")
        setExpandedSection("personal");
        return;
      }
      //else if (!basicHitDetails.hitLabourLicenseNo || basicHitDetails.hitLabourLicenseNo?.length == 0) {
      //    setErrorMessage({ labourLicenseNoError: "Please enter Labour License No  " });
      //    return;
      //}
      //else if (!basicHitDetails.labourLicenseEndDate || basicHitDetails.labourLicenseEndDate?.length == 0) {
      //    setErrorMessage({ labourLicenseNoError: "Please enter Labour License End Date  " });
      //    return;
      //}
    }
    if (basicHitDetails?.address?.length == 0) {
      setErrorMessage({ addressError: "Please enter Address" });
      toast.error("Please enter Address")
      setExpandedSection("personal");
      return;
    }
    else if (basicHitDetails.pincode?.length < 6) {
      setErrorMessage({ pincodeError: "Please enter 6 digit Pincode" });
      toast.error("Please enter 6 digit Pincode")
      setExpandedSection("personal");
      return;
    }
    else if (basicHitDetails.state.length == 0) {
      setErrorMessage({ searchError: "Please click on search button" });
      toast.error("Please click on search button")
      setExpandedSection("bank");
      return;
    }
    if (userRole !== ROLES.ItAdmin) {
      if (!basicHitDetails.bankAccountNumber || basicHitDetails.bankAccountNumber.length == 0 || !VALIDATION.bankAccountNumberValidation(basicHitDetails.bankAccountNumber)) {
        setErrorMessage({ accountNumberError: 'Please enter valid Account Number' });
        toast.error('Please enter valid Account Number')
        setExpandedSection("bank");
        return;
      }
      else if (!basicHitDetails.bankAccountHolderName || basicHitDetails.bankAccountHolderName.length == 0 || !VALIDATION.bankAccountNameValidation(basicHitDetails.bankAccountHolderName)) {
        setErrorMessage({ accountHolderNameError: "Please enter Account Holder's Name" });
        toast.error("Please enter Account Holder's Name")
        setExpandedSection("bank");
        return;
      }
      else if (!basicHitDetails.bankIfscCode || basicHitDetails.bankIfscCode.length == 0 || !VALIDATION.ifscValidation(basicHitDetails.bankIfscCode)) {
        setErrorMessage({ ifscCodeError: "Please enter valid IFSC Code" });
        toast.error("Please enter valid IFSC Code")
        setExpandedSection("bank");
        return;
      }
      else if (!basicHitDetails.bankBranch || basicHitDetails.bankBranch.length == 0) {
        setErrorMessage({ ifscCodeError: "Please enter valid IFSC code and search" });
        toast.error("Please enter valid IFSC code and search")
        setExpandedSection("bank");
        return;
      }
      else if (bankdoc.length == 0) {
        setErrorMessage({ bankDocError: "Please upload bank document" });
        toast.error("Please upload bank document")
        setExpandedSection("bank");
        return;
      }
      else if (bankStatement.length == 0) {
        setErrorMessage({ bankStatementError: "Please upload bank statement" });
        toast.error("Please upload bank statement")
        setExpandedSection("bank");
        return;
      }

      else if (!basicHitDetails.hitTradeLicenseNo || basicHitDetails.hitTradeLicenseNo?.length == 0) {
        setErrorMessage({ tradeLicenseNoError: "Please enter Trade License No " });
        toast.error("Please enter Trade License No ")
        setExpandedSection("agreement");
        return;
      }
      else if (!basicHitDetails.tradeLicenseEndDate || basicHitDetails.tradeLicenseEndDate?.length == 0) {
        setErrorMessage({ tradeLicenseNoError: "Please enter Trade License End Date " });
        toast.error("Please enter Trade License End Date ")
        setExpandedSection("agreement");
        return;
      }
      var tardeLicense = documentsArray && documentsArray.filter((item) => item.documentType === "TransportationTradeLicense" && (item.isActive == 1 || item.isActive == 3));
      if (tardeLicense.length == 0) {
        setErrorMessage({ tradeLicenseDocError: "Please upload transportation trade license document" });
        toast.error("Please upload transportation trade license document")
        setExpandedSection("agreement");
        return;
      }
      //var labourLicense = documentsArray && documentsArray.filter((item) => item.documentType === "LabourLicence" && item.isActive == 1);
      //if (labourLicense.length == 0) {
      //    setErrorMessage({ labourLicenseDocError: "Please upload labour license document" });
      //    return;
      //}
    }
    var gst = documentsArray && documentsArray.filter((item) => item.documentType === "GST" && (item.isActive == 1 || item.isActive == 3));
    if (!agencyUpdatedDetails.gstNumber || agencyUpdatedDetails.gstNumber.length == 0 || !VALIDATION.gstNumberValidation(agencyUpdatedDetails.gstNumber)) {
      setErrorMessage({ ...errorMessage, gstNumberError: "Please enter valid GST No " });
      toast.error("Please enter valid GST No ")
      setExpandedSection("agreement");
      return;
    }
    if (gst.length == 0) {
      setErrorMessage({ ...errorMessage, gstNumberError: "", gstDocError: "Please upload gst document" });
      toast.error("Please upload gst document")
      setExpandedSection("agreement");
      return;
    }
    var agreement = documentsArray && documentsArray.filter((item) => item.documentType === "LOI_ABRPLAgreement" && (item.isActive == 1 || item.isActive == 3));
    if (agreement.length == 0) {
      setErrorMessage({ ...errorMessage, gstNumberError: "", gstDocError: "", agreementDocError: "Please upload LOI and agreement document" });
      toast.error("Please upload LOI and agreement document")
      setExpandedSection("agreement");
      return;
    }
    if (agencyUpdatedDetails?.hitDriverDetails.length == 0 || agencyUpdatedDetails?.hitVehicleDetails.length == 0) {
      setErrorMessage({ ...errorMessage, gstNumberError: "", gstDocError: "", agreementDocError: "", manpowerVechicletableError: "Please add atleast one Driver & Vehicle Details" })
      toast.error("Please add atleast one Driver & Vehicle Details")
      setExpandedSection("vehicle");
      return;
    }
    else {
      setErrorMessage({ ...errorMessage, manpowerVechicletableError: "" });
      showPreview();
    }
  }

  function getHitDetails() {
    loaderService.showLoader();
    apiClient
      .post(GET_STAKEHOLDER_BY_URN,
        {
          "urn": urn,
          "type": "hit",
          "isScrutinyView": "true"
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        loaderService.hideLoader();
        setHitDetails(response.data);
        let stakeHolderDetailsLocal = response.data.stakeHolder;
        setStakeHolderDetails(response.data.stakeHolder);
        if (stakeHolderDetailsLocal) {
          const loggedInUser = decoded.extension_URN ? stakeHolderDetailsLocal?.id : uuid
          if (stakeHolderDetailsLocal?.registrationStatus === "Scrutiny_Initiated" && stakeHolderDetailsLocal?.scrutinyStatus !== "Approved" && stakeHolderDetailsLocal?.scrutinyStatus !== "Rejected"
            &&
            (userRole === ROLES.RegistrationScruitnizer || decoded.extension_URN || userRole === ROLES.RegInCharge || userRole === ROLES.LeadRegScrutinizer || userRole === ROLES.RegSuperVisor)
          ) {
            setShowCommentSection(true);
          }
          if ((stakeHolderDetailsLocal?.scrutinyStatus === "Approved" || stakeHolderDetailsLocal?.registrationStatus === "ResourceUpdate_Initiated") && (userRole === ROLES.RegistrationScruitnizer && state?.userType === "Internal")) {
            setShowCommentSection(true);
            setRegScruResourceUpdate(true);
          }
          if (stakeHolderDetailsLocal?.scrutinyStatus !== "Rejected" && (userRole === ROLES.ItAdmin || userRole === RESOURCE_ROLES.PlantSCMMember || (decoded.extension_URN && (stakeHolderDetailsLocal?.scrutinyStatus === "Approved" || (!stakeHolderDetailsLocal?.registrationCompleted && stakeHolderDetailsLocal?.registrationStatus !== "Scrutiny_Initiated"))) || (userRole === ROLES.RegistrationScruitnizer && stakeHolderDetailsLocal?.registrationStatus === "Scrutiny_Initiated" && !stakeHolderDetailsLocal?.registrationCompleted) || (userRole === ROLES?.RegistrationScruitnizer && state?.userType === "Internal" && stakeHolderDetailsLocal?.scrutinyStatus === "Approved"))) {
            setEnableSaveSubmitButtons(true);
          }
          if (stakeHolderDetailsLocal?.registrationCompleted && stakeHolderDetailsLocal?.currentOwnerID === loggedInUser && stakeHolderDetailsLocal?.scrutinyStatus !== "Approved" && stakeHolderDetailsLocal?.scrutinyStatus !== "Rejected") {
            // && state?.registerByScruOtpValidated for otp validation in pending clarification add after userole in below line
            if (((userRole === ROLES.RegistrationScruitnizer) || decoded.extension_URN) && stakeHolderDetailsLocal?.scrutinyStatus == "Pending_Clarification") {
              setShowClarificationButton(true);
              setEnableSaveSubmitButtons(true);
            }
            if (userRole === ROLES.RegInCharge || userRole === ROLES.LeadRegScrutinizer || (userRole === ROLES.RegistrationScruitnizer && stakeHolderDetailsLocal?.scrutinyStatus != "Pending_Clarification")) {

              setShowWorkFlowButtons(true);
            }
          }
          getAllComments(stakeHolderDetailsLocal?.hitMasters[0]?.regStakeholderMasterId, setCommentsData);
        }
      })
      .catch(function (error) {
        loaderService.hideLoader();
        console.log(error);
      });
  }

  const getRegistrationStatus = () => {
    var regStatus = hitDetails?.stakeHolder?.registrationStatus;
    if (userRole != ROLES.ItAdmin) {
      if (hitDetails?.stakeHolder?.registrationStatus === "Approved" && userRole === RESOURCE_ROLES.PlantSCMMember || (userRole === ROLES?.RegistrationScruitnizer && state?.userType === "Internal")) {
        regStatus = "ResourceUpdate_Initiated";
      }
    }
    return regStatus;
  }

  const getSubmit = () => {
    if (userRole !== ROLES.ItAdmin && buttonAction === "submit") {
      return true
    }
    else {
      return false
    }
  }

  const stakeHolder = hitDetails?.stakeHolder;
  const hitMaster = stakeHolder?.hitMasters[0];

  const initialData = {
    "id": stakeHolder?.id,
    "name": stakeHolder?.name,
    "contactPersonName": stakeHolder?.contactPersonName,
    "contactPersonFirstname": stakeHolder?.contactPersonFirstname,
    "contactPersonMiddlename": stakeHolder?.contactPersonMiddlename,
    "contactPersonLastname": stakeHolder?.contactPersonLastname,
    "contactPersonGender": stakeHolder?.contactPersonGender,
    "contactPersonSalutation": stakeHolder?.contactPersonSalutation,
    "mobileNo": stakeHolder?.mobileNo,
    "bankAccountNumber": stakeHolder?.bankAccountNumber,
    "bankAccountHolderName": stakeHolder?.bankAccountHolderName,
    "bankBranch": stakeHolder?.bankBranch,
    "bankIfscCode": stakeHolder?.bankIfscCode,
    "bankName": stakeHolder?.bankName,
    "panNumber": stakeHolder?.panNumber,
    "govtIdCardType": stakeHolder?.govtIdCardType,
    "govtIdCardNumber": stakeHolder?.govtIdCardNumber,
    "otherGovtCardType": stakeHolder?.otherGovtCardType,
    "emailId": stakeHolder?.emailId,
    "category": stakeHolder?.category,
    "urn": stakeHolder?.urn,
    "isOtpValidated": stakeHolder?.isOtpValidated,
    "preregistrationShortlisted": stakeHolder?.preregistrationShortlisted,
    "registrationStatus": stakeHolder?.registrationStatus,
    "scrutinyStatus": stakeHolder?.scrutinyStatus,
    "stakeholderStatus": stakeHolder?.stakeholderStatus,
    "createdOn": stakeHolder?.createdOn,
    "createdBy": stakeHolder?.createdBy,
    "updatedOn": stakeHolder?.updatedOn,
    "updatedBy": stakeHolder?.updatedBy,
    "isActive": stakeHolder?.isActive,
    "acceptedTerms": stakeHolder?.acceptedTerms,
    "hitDetails": {
      "id": hitMaster?.id,
      "regStakeholderMasterId": hitMaster?.regStakeholderMasterId,
      "pincode": hitMaster?.pincode,
      "address": hitMaster?.address,
      "state": hitMaster?.state,
      "district": hitMaster?.district,
      "revenueCircle": hitMaster?.revenueCircle,
      "blockName": hitMaster?.blockName,
      "subDivision": hitMaster?.subDivision,
      "hitTradeLicenseNo": hitMaster?.hitTradeLicenseNo,
      "tradeLicenseEndDate": hitMaster?.tradeLicenseEndDate,
      "hitLabourLicenseNo": hitMaster?.hitLabourLicenseNo,
      "labourLicenseEndDate": hitMaster?.labourLicenseEndDate,
      "gstNumber": hitMaster?.gstNumber,
      "bankStatement": hitMaster?.bankStatement,
      "totalManpower": hitMaster?.totalManpower && Number(hitMaster?.totalManpower),
      "companyType": hitMaster?.companyType,
      "locationGeocode": hitMaster?.locationGeocode,
      "documentId": hitMaster?.documentId,
      "applicantType": hitMaster?.applicantType,
      "agreementStartDate": hitMaster?.agreementStartDate,
      "agreementEndDate": hitMaster?.agreementEndDate,
      "certificateType": hitMaster?.certificateType,
      "certificateNumber": hitMaster?.certificateNumber,
      "isActive": hitMaster?.isActive,
      "createdOn": hitMaster?.createdOn,
      "createdBy": hitMaster?.createdBy,
      "updatedOn": hitMaster?.updatedOn,
      "updatedBy": hitMaster?.updatedBy,
      "documents": hitMaster?.documents,
      "hitDriverDetails": hitMaster?.hitDriverDetails,
      "hitVehicleDetails": hitMaster?.hitVehicleDetails,
      "hitHarvesterDetails": hitMaster?.hitHarvesterDetails,
      "isMSME": stakeHolder?.isMSME,
      "msmeCategory": stakeHolder?.msmeCategory,
    }
  }

  const isMSMENo =
    isMSMERadio === 0 ||
    isMSMERadio === "NO";


  // const filteredDocuments = isMSMENo
  //   ? documentsArray?.filter(
  //     (doc) => doc.documentType !== "MSME_Certificate"
  //   )
  //   : documentsArray;

  const filteredDocuments = documentsArray?.map(doc => {
    if (doc.documentType === "MSME_Certificate") {
      return {
        ...doc,
        isActive: isMSMENo ? 0 : 1
      };
    }
    return doc;
  });

  const finalData = {
    "id": stakeHolder?.id,
    "name": basicHitDetails?.name,
    "contactPersonName": stakeHolder?.contactPersonName,
    "contactPersonFirstname": basicHitDetails?.contactPersonFirstName,
    "contactPersonMiddlename": basicHitDetails?.contactPersonMiddleName,
    "contactPersonLastname": basicHitDetails?.contactPersonLastName,
    "contactPersonGender": basicHitDetails?.contactPersonGender,
    "contactPersonSalutation": basicHitDetails?.contactPersonSalutation,
    "mobileNo": basicHitDetails?.mobileNo,
    "bankAccountNumber": basicHitDetails?.bankAccountNumber,
    "bankAccountHolderName": basicHitDetails?.bankAccountHolderName,
    "bankBranch": basicHitDetails?.bankBranch,
    "bankIfscCode": basicHitDetails?.bankIfscCode,
    "bankName": basicHitDetails?.bankName,
    "panNumber": basicHitDetails?.panNumber,
    "govtIdCardType": basicHitDetails?.govtIdCardType,
    "govtIdCardNumber": basicHitDetails?.govtIdCardNumber,
    "otherGovtCardType": basicHitDetails?.otherGovtCardType,
    "emailId": basicHitDetails?.emailId,
    "category": stakeHolder?.category,
    "urn": stakeHolder?.urn,
    "isOtpValidated": stakeHolder?.isOtpValidated,
    "preregistrationShortlisted": stakeHolder?.preregistrationShortlisted,
    "registrationStatus": getRegistrationStatus(),
    "scrutinyStatus": stakeHolder?.scrutinyStatus,
    "stakeholderStatus": stakeHolder?.stakeholderStatus,
    "createdOn": stakeHolder?.createdOn,
    "createdBy": stakeHolder?.createdBy,
    "updatedOn": stakeHolder?.updatedOn,
    "updatedBy": stakeHolder?.updatedBy,
    "isActive": stakeHolder?.isActive,
    "acceptedTerms": stakeHolder?.acceptedTerms,
    "hitDetails": {
      "id": hitMaster?.id,
      "regStakeholderMasterId": hitMaster?.regStakeholderMasterId,
      "pincode": basicHitDetails?.pincode,
      "address": basicHitDetails?.address,
      "state": basicHitDetails?.state,
      "district": basicHitDetails?.district,
      "revenueCircle": basicHitDetails?.revenueCircle,
      "blockName": basicHitDetails?.blockName,
      "subDivision": basicHitDetails?.subDivision,
      "hitTradeLicenseNo": basicHitDetails?.hitTradeLicenseNo,
      "tradeLicenseEndDate": basicHitDetails?.tradeLicenseEndDate,
      "hitLabourLicenseNo": basicHitDetails?.hitLabourLicenseNo,
      "labourLicenseEndDate": basicHitDetails?.labourLicenseEndDate,
      "gstNumber": agencyUpdatedDetails ? agencyUpdatedDetails?.gstNumber : hitMaster?.gstNumber,
      "bankStatement": hitMaster?.bankStatement,
      "totalManpower": agencyUpdatedDetails ? agencyUpdatedDetails?.totalManpower : hitMaster?.totalManpower,
      "companyType": hitMaster?.companyType,
      "locationGeocode": hitMaster?.locationGeocode,
      "documentId": hitMaster?.documentId,
      "applicantType": basicHitDetails?.applicantType,
      "agreementStartDate": agencyUpdatedDetails ? agencyUpdatedDetails?.agreementStartDate : hitMaster?.agreementStartDate,
      "agreementEndDate": agencyUpdatedDetails ? agencyUpdatedDetails?.agreementEndDate : hitMaster?.agreementEndDate,
      "certificateType": basicHitDetails?.certificateType,
      "certificateNumber": basicHitDetails?.certificateNumber,
      "isActive": hitMaster?.isActive,
      "createdOn": hitMaster?.createdOn,
      "createdBy": hitMaster?.createdBy,
      "updatedOn": hitMaster?.updatedOn,
      "updatedBy": hitMaster?.updatedBy,
      "documents": filteredDocuments,
      "isMSME": isMSMERadio === "YES" ? 1 : 0,
      "msmeCategory": isMSMERadio === "YES" ? msmeCategory : null,
      "hitDriverDetails": agencyUpdatedDetails ? agencyUpdatedDetails?.hitDriverDetails : hitMaster?.hitDriverDetails,
      "hitVehicleDetails": agencyUpdatedDetails ? agencyUpdatedDetails?.hitVehicleDetails : hitMaster?.hitVehicleDetails,
      "hitHarvesterDetails": agencyUpdatedDetails ? agencyUpdatedDetails?.hitHarvesterDetails : hitMaster?.hitHarvesterDetails
    }
  }

  function updateHit() {
    if (stakeHolder) {
      loaderService.showLoader()
      apiClient
        .post(UPDATE_HIT + `?IsRegistrationSubmit=${getSubmit()}`,
          finalData,
          {
            headers: {
              Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
            }
          }
        )
        .then((response) => {
          loaderService.hideLoader();
          const updateHitResponse = response?.data
          setCallUpdateApi(false);
          if (updateHitResponse?.isSuccess) {
            getHitDetails();
            if (buttonAction === "preview") {
              setCurrentPage("preview")
            }
            if (buttonAction === "submit" || buttonAction === "save") {
              toast.success(updateHitResponse?.message);
            }
            if (buttonAction === "submit" && userRole === ROLES?.RegistrationScruitnizer && state?.userType === "Internal" && stakeHolderDetails?.scrutinyStatus === "Approved") {
              onSubmit();
            }
            if (buttonAction === "submit") {
              if (decoded.extension_URN) {
                navigate('/dashboardHome/dashboardStakeHolder');
              }
              else if (userRole === RESOURCE_ROLES.PlantSCMMember) {
                navigate('/resourcedashboard/searchByURN');
              }
              else if (userRole === ROLES.ItAdmin) {
                navigate('/sidebar/viewAllActiveApplications');
              }
              else if (userRole === ROLES.RegistrationScruitnizer && state?.userType === "Internal") {
                navigate('/registrationHome/dashboard');
              }
              else if (userRole === ROLES.RegistrationScruitnizer) {
                setCallWorkFlowApi(true);
              }
              else {
                navigate(-1);
              }
            }
          }
          else {
            toast.error(updateHitResponse?.message);
            setCurrentPage("registrationDetails")
          }
        })
        .catch(function (error) {
          console.log(error);
          loaderService.hideLoader()

        });
    }
  }

  const onSubmit = () => {
    loaderService.showLoader();
    apiClient.post(INITIATE_WORKFLOW_FOR_REG_SCRU,
      {
        "stakeholderMappings": [
          {
            "scrutinizerId": getLocalStorageItem('uuid'),
            "stakeholderID": stakeHolderDetails?.id,
            "stakeholderState": stakeHolderDetails?.hitMasters?.[0]?.state,
            "stakeholderDistrict": stakeHolderDetails?.hitMasters?.[0]?.district,
            "loggedInUserID": getLocalStorageItem('uuid'),
            "isActive": 1,
            // "leadScrutinizerID": "3fa85f64-5717-4562-b3fc-2c963f66afa6"
          }
        ]
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
      .then((response) => {
        if (response.data.isSuccess === true) {
          onActionWorflowSubmit();
        } else {
          toast.error(response.data?.message)
        }
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();

      });
  };

  const onActionWorflowSubmit = () => {
    loaderService.showLoader();
    apiClient.post(ALLOCATE_WORKFLOW,
      {
        "stakeHolderMasterID": stakeHolderDetails?.id,
        "workflowInitiatorID": getLocalStorageItem('uuid'),
        "workflowReceiverID": "",
        "workflowAction": "Approve",
        "status": "",
        "isStakeHolderAction": false,
        "workflowInitiatorRole": localStorage.getItem('role'),
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
      .then((response) => {
        if (response.data.isSuccess === true) {
          toast.success(response.data?.message);
          if (localStorage.getItem('uuid'))
            navigate('/registrationHome/dashboard');
          else
            navigate('/dashboardHome/dashboardStakeHolder');
        } else {
          toast.error(response.data?.message)
        }
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();

      });
  };

  const enableFieldFunction = (sectionEnabled, isPreg, isNew) => {
    if (state?.viewOnly) {
      return false
    }
    if (userRole === ROLES.ItAdmin) {
      return true
    }
    if (
      userRole === ROLES.RegistrationScruitnizer &&
      state?.userType === "Internal"
    ) { return true; }
    else if (enableSaveSubmitButtons && sectionEnabled && !isPreg) {
      return true
    }
    else if (isNew) {
      return true
    }
    else return false
  }

  return (
    <HitContext.Provider value={{
      userType: state?.userType, viewOnly: state?.viewOnly, regScruResourceUpdate, setRegScruResourceUpdate, hitDetails, basicHitDetails, setBasicHitDetails, agencyUpdatedDetails, setAgencyUpdatedDetails, documentsArray, setDocumentsArray, bankDetails, setBankDetails, address, setAddress, otpValue, setOtpValue, verifyMobileNo, setVerifyMobileNo, otpHidden, setOtpHidden, mobileOTPValidated, setMobileOTPValidated, personalDetailsSectionOk, setPersonalDetailsSectionOk, bankDetailsSectionOk, setBankDetailsSectionOk, agreementDetailsSectionOk, setAgreementDetailsSectionOk, vehicleDetailsSectionOk, setVehicleDetailsSectionOk, shouldActOnSection, setShouldActOnSection, showWorkFlowButtons, showClarificationButton, enableSaveSubmitButtons, stakeHolderDetails, showCommentSection, commentsData, setCommentsData, registerByScruOtpValidated: state?.registerByScruOtpValidated, comments, setComments, enableFieldFunction, currentPage, buttonAction, setCurrentPage, setButtonAction, errorMessage, setErrorMessage, expandedSection, setExpandedSection, setCallUpdateApi, callWorkFlowApi, isMSMERadio,
      setIsMSMERadio,
      msmeCategory,
      setMsmeCategory,
    }}>
      <>
        {currentPage === "registrationDetails" && hitDetails && <Container maxWidth="xxl" >
          {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>REG22</p>}
          <Stack direction="row" alignItems="center" spacing={1} mb={3}>
            <BackButton navigate={navigate} />
            <Typography variant="h5" gutterBottom>
              {t('reg.registrationDetails')}
            </Typography>
          </Stack>
          <Grid container spacing={2}>
            <Grid item xs={12} lg={12}>
              <TextField
                required
                disabled
                type="text"
                label="URN"
                value={urn || ''}
              />
            </Grid>
            <BasicDetails />
            <AgencyDetails />
          </Grid>
          <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }}>
            {!showWorkFlowButtons &&
              <Button
                sx={{ minWidth: 100 }}
                variant="contained"
                disabled={!enableSaveSubmitButtons || state?.viewOnly}
                onClick={() => { (!_.isEqual(finalData, initialData) ? setCallUpdateApi(true) : toast.warning("No modifications to be saved")); setButtonAction("save"); }}
                startIcon={<SaveIcon />}
              >{t('preReg.save')}
              </Button>
            }
            <Button
              sx={{ minWidth: 100, ml: 1 }}
              variant="contained"
              onClick={() => checkValidations()}
              startIcon={<PreviewIcon />}
            >{t('preReg.preview')}</Button>
          </Box>
        </Container>}
        {currentPage === "preview" &&
          <Grid xs={12} md={12} id='divPreview'>
            <Preview urn={urn} goBack={onGoBack} callWorkFlowApi={callWorkFlowApi} stakeholderType="HIT" />
          </Grid>}
      </>
    </HitContext.Provider>
    // <>
    //   {prevPage === true && <BasicDetails key={basic} hitDetails={hitDetails} urn={urn} saveAndExitCallback={saveAndExitCallback} updateBasicCallback={updateBasicCallback} appCountDisplay={appCountDisplay} />}
    //   {nextPage === true && <AgencyDetails key={agency} hitDetails={hitDetails} urn={urn} saveAndExitCallback={saveAndExitCallback} updateAgencyCallback={updateAgencyCallback} saveHit={saveHit} documents={documents} onPreviousCallback={onPreviousCallback} appCountDisplay={appCountDisplay} updateAgencyDetails={updateAgencyDetails} reloadAgency={reloadAgency} />}
    // </>
  );
}
export default RegistrationDetailsHit;
export const useHitContextData = () => useContext(HitContext)